/* TheBandArm — ba-core.js (built; parts-sha256: bb6b5953a9922fa0) */
(function (G) {
  'use strict';
  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  var CURVES = {
    linear: function (t) { return t; },
    easeInOutQuad: function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; },
    easeOutQuart: function (t) { return 1 - Math.pow(1 - t, 4); },
    easeInOutCubic: function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; },
    easeInSin: function (t) { return 1 - Math.cos(t * Math.PI / 2); }
  };
  function bezier(x1, y1, x2, y2) {
    x1 = clamp(x1, 0, 1); x2 = clamp(x2, 0, 1);
    var ax = 1 - 3 * x2 + 3 * x1, bx = 3 * x2 - 6 * x1, cx = 3 * x1;
    var ay = 1 - 3 * y2 + 3 * y1, by = 3 * y2 - 6 * y1, cy = 3 * y1;
    function sx(t) { return ((ax * t + bx) * t + cx) * t; }
    function sy(t) { return ((ay * t + by) * t + cy) * t; }
    function dx(t) { return (3 * ax * t + 2 * bx) * t + cx; }
    function solve(x) {
      var t = x, i, d, e;
      for (i = 0; i < 8; i++) {
        e = sx(t) - x;
        if (Math.abs(e) < 1e-6) return t;
        d = dx(t);
        if (Math.abs(d) < 1e-6) break;
        t -= e / d;
      }
      var lo = 0, hi = 1;
      t = x;
      for (i = 0; i < 30; i++) {
        e = sx(t);
        if (Math.abs(e - x) < 1e-6) return t;
        if (e < x) lo = t; else hi = t;
        t = (lo + hi) / 2;
      }
      return t;
    }
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      return sy(solve(x));
    };
  }
  var BEZ = /^cubic-bezier\(\s*(-?\d*\.?\d+)\s*,\s*(-?\d*\.?\d+)\s*,\s*(-?\d*\.?\d+)\s*,\s*(-?\d*\.?\d+)\s*\)$/;
  function curve(name) {
    if (!name) return CURVES.linear;
    if (typeof name === 'function') return name;
    if (CURVES[name]) return CURVES[name];
    var m = BEZ.exec(String(name).trim());
    if (m) return bezier(+m[1], +m[2], +m[3], +m[4]);
    throw new Error('unknown curve "' + name + '"');
  }
  var TOKEN = /\s*(?:(\d+(?:\.\d+)?|\.\d+)(vh|vw|px|h)?|css\(\s*(--[\w-]+)\s*\)|(min|max|clamp)(?=\s*\()|(a\d+[tbh]|vh|vw|[tbh])(?!\w)|([-+*\/(),]))/y;
  var compiled = {};
  function compile(src) {
    src = String(src);
    if (compiled[src]) return compiled[src];
    var toks = [], pos = 0, m;
    while (pos < src.length) {
      if (/^\s*$/.test(src.slice(pos))) break;
      TOKEN.lastIndex = pos;
      m = TOKEN.exec(src);
      if (!m) throw new Error('cannot read "' + src + '" at ' + pos);
      pos = TOKEN.lastIndex;
      if (m[1] !== undefined) toks.push({ k: 'n', v: parseFloat(m[1]), u: m[2] || '' });
      else if (m[3]) toks.push({ k: 'c', v: m[3] });
      else if (m[4]) toks.push({ k: 'f', v: m[4] });
      else if (m[5]) toks.push({ k: 'i', v: m[5] });
      else toks.push({ k: 'o', v: m[6] });
    }
    var i = 0;
    function isOp(v) { var t = toks[i]; return !!t && t.k === 'o' && t.v === v; }
    function expect(v) {
      if (!isOp(v)) throw new Error('expected "' + v + '" in "' + src + '"');
      i++;
    }
    function expr() {
      var l = term();
      while (isOp('+') || isOp('-')) {
        var op = toks[i++].v, r = term();
        l = (function (a, b, plus) {
          return plus ? function (E) { return a(E) + b(E); } : function (E) { return a(E) - b(E); };
        })(l, r, op === '+');
      }
      return l;
    }
    function term() {
      var l = unary();
      while (isOp('*') || isOp('/')) {
        var op = toks[i++].v, r = unary();
        l = (function (a, b, times) {
          return times ? function (E) { return a(E) * b(E); } : function (E) { return a(E) / b(E); };
        })(l, r, op === '*');
      }
      return l;
    }
    function unary() {
      if (isOp('-')) { i++; var u = unary(); return function (E) { return -u(E); }; }
      if (isOp('+')) { i++; return unary(); }
      return primary();
    }
    function primary() {
      var t = toks[i++];
      if (!t) throw new Error('"' + src + '" ends too soon');
      if (t.k === 'n') {
        var n = t.v;
        if (t.u === 'vh') return function (E) { return n / 100 * E.vh; };
        if (t.u === 'vw') return function (E) { return n / 100 * E.vw; };
        if (t.u === 'h') return function (E) { return n / 100 * E.h; };
        return function () { return n; };
      }
      if (t.k === 'c') {
        var name = t.v;
        return function (E) { return E.css(name); };
      }
      if (t.k === 'i') {
        var id = t.v;
        if (id.length <= 2 && id.charAt(0) !== 'a') return function (E) { return E[id]; };
        var k = parseInt(id.slice(1), 10), part = id.charAt(id.length - 1);
        return function (E) {
          var a = E.a && E.a[k];
          if (!a) throw new Error('anchor ' + k + ' is not declared');
          return a[part];
        };
      }
      if (t.k === 'f') {
        var fn = t.v;
        expect('(');
        var args = [expr()];
        while (isOp(',')) { i++; args.push(expr()); }
        expect(')');
        if (fn === 'clamp' && args.length !== 3) throw new Error('clamp() takes three values in "' + src + '"');
        return function (E) {
          var v = [];
          for (var j = 0; j < args.length; j++) v.push(args[j](E));
          if (fn === 'min') return Math.min.apply(null, v);
          if (fn === 'max') return Math.max.apply(null, v);
          return clamp(v[1], v[0], v[2]);
        };
      }
      if (t.k === 'o' && t.v === '(') {
        var e = expr();
        expect(')');
        return e;
      }
      throw new Error('unexpected "' + t.v + '" in "' + src + '"');
    }
    var out = expr();
    if (i !== toks.length) throw new Error('"' + src + '" has more after the end');
    compiled[src] = out;
    return out;
  }
  function floorStep(shown, target, dt, floor) {
    if (!(floor > 0)) return target;
    var most = dt / floor;
    return shown + clamp(target - shown, -most, most);
  }
  function smoothStep(shown, target, dt, smooth) {
    if (!(smooth > 0)) return target;
    var d = target - shown;
    if (Math.abs(d) < 0.001) return target;
    return shown + d * (1 - Math.exp(-dt / smooth));
  }
  var PURE = { clamp: clamp, curve: curve, compile: compile, floorStep: floorStep, smoothStep: smoothStep };
  if (!G || !G.document) {
    if (typeof module !== 'undefined' && module.exports) module.exports = PURE;
    return;
  }
  if (G.baScroll) return;
  var doc = G.document, html = doc.documentElement;
  var groups = [];
  var frames = [], readQ = [], writeQ = [], events = [];
  var listeners = {};
  var raf = 0, lastNow = 0, prevY = -1;
  var dirty = true, resizePending = false, resizeT = 0, lastMeasure = 0, pageH = -1;
  var vh = G.innerHeight || 0, vw = html.clientWidth || 0, band = '';
  var probe = null, warned = {};
  var mqS = G.matchMedia('(max-width: 734px)'), mqM = G.matchMedia('(max-width: 1068px)');
  var mqReduce = G.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = mqReduce.matches;
  function warn(key, msg) {
    if (warned[key]) return;
    warned[key] = 1;
    if (G.console && console.warn) console.warn('[ba-scroll] ' + msg);
  }
  function emit(name, detail) {
    (listeners[name] || []).slice().forEach(function (fn) {
      try { fn(detail); } catch (e) { warn('on:' + name, name + ' listener failed: ' + e.message); }
    });
  }
  function book() { if (!raf) raf = G.requestAnimationFrame(tick); }
  function busy() { return groups.length > 0 || frames.length > 0 || readQ.length > 0 || writeQ.length > 0; }
  function bandNow() { return mqS.matches ? 's' : mqM.matches ? 'm' : 'l'; }
  function ensureProbe() {
    if (probe && probe.isConnected) return probe;
    probe = doc.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.setAttribute('data-ba-scroll-probe', '');
    probe.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100vh;height:100lvh;' +
      'visibility:hidden;pointer-events:none;z-index:-1;contain:strict;';
    html.appendChild(probe);
    return probe;
  }
  function docTop(el) {
    var y = 0;
    for (var e = el; e; e = e.offsetParent) y += e.offsetTop;
    return y;
  }
  function unstuck(el, what) {
    var e = el;
    while (e && e !== doc.body && G.getComputedStyle(e).position === 'sticky') e = e.parentElement;
    if (e !== el) warn('sticky:' + what, what + ' is sticky and cannot be measured; its nearest non-sticky ancestor is used');
    return e || el;
  }
  function box(el) {
    var t = docTop(el), h = el.offsetHeight;
    return { t: t, h: h, b: t + h };
  }
  function cssNumber(g, name, asMs) {
    if (!(name in g.css)) g.css[name] = G.getComputedStyle(g.root).getPropertyValue(name).trim();
    var raw = g.css[name], n = parseFloat(raw);
    if (isNaN(n)) throw new Error(name + ' is not set on the section');
    if (asMs) return /ms$/.test(raw) ? n : /s$/.test(raw) ? n * 1000 : n;
    if (/vh$/.test(raw)) return n / 100 * vh;
    if (/vw$/.test(raw)) return n / 100 * vw;
    return n;
  }
  function msOption(v, g) {
    if (typeof v === 'string' && /^--/.test(v)) return cssNumber(g, v, true);
    return +v || 0;
  }
  function fail(m, err) {
    m.failed = err && err.message ? err.message : String(err);
    try { m.el.setAttribute('data-ba-moment-error', m.failed); } catch (_) {}
    warn('fail:' + m.failed, m.failed);
  }
  function measureMoment(m, g) {
    try {
      var E = box(unstuck(m.el, 'a moment\'s element'));
      E.vh = vh; E.vw = vw; E.a = [];
      for (var i = 0; i < m.anchorSel.length; i++) {
        var sel = m.anchorSel[i];
        var a = g.root.querySelector(sel) || doc.querySelector(sel);
        if (!a) throw new Error('anchor "' + sel + '" was not found');
        E.a.push(box(unstuck(a, 'anchor "' + sel + '"')));
      }
      E.css = function (name) { return cssNumber(g, name, false); };
      m.s = m.start(E);
      m.e = m.end ? m.end(E) : m.s;
      if (!isFinite(m.s) || !isFinite(m.e)) throw new Error('a position did not work out to a number');
      m.floorMs = msOption(m.o.floor, g);
      m.smooth = msOption(m.o.smooth, g);
      if (m.failed) { m.failed = null; m.el.removeAttribute('data-ba-moment-error'); }
    } catch (err) { fail(m, err); }
  }
  function measureGroup(g) {
    g.css = {};
    var lo = Infinity, hi = -Infinity;
    for (var i = 0; i < g.moments.length; i++) {
      var m = g.moments[i];
      measureMoment(m, g);
      if (m.failed) continue;
      if (m.s < lo) lo = m.s;
      if (m.e > hi) hi = m.e;
      m.fresh = m.fresh || false;
    }
    if (lo === Infinity) { lo = 0; hi = 0; }
    if (hi - lo < vh) { lo -= vh / 2; hi += vh / 2; }
    g.min = lo; g.max = hi;
    g.dirty = false;
    g.force = true;
  }
  function measure(all, now) {
    var p = ensureProbe();
    vh = p.clientHeight || G.innerHeight || vh;
    vw = p.clientWidth || html.clientWidth || vw;
    var b = bandNow(), changed = b !== band;
    band = b;
    for (var i = 0; i < groups.length; i++) {
      if (all || groups[i].dirty) measureGroup(groups[i]);
    }
    pageH = html.scrollHeight;
    lastMeasure = now || 0;
    dirty = false;
    if (changed) events.push(function () { emit('band', band); });
    if (all) events.push(function () { emit('refresh'); });
  }
  function checkResize(now) {
    if (!resizePending) return;
    var p = ensureProbe(), h = p.clientHeight, w = p.clientWidth;
    if (h === vh && w === vw && bandNow() === band) { resizePending = false; return; }
    if (now - lastMeasure < 100) {
      if (!resizeT) resizeT = G.setTimeout(function () { resizeT = 0; resizePending = true; book(); }, 100);
      resizePending = false;
      return;
    }
    resizePending = false;
    dirty = true;
  }
  var SETTABLE = /^(--[\w-]+|opacity)$/;
  function Moment(el, o) {
    if (o.start === undefined || o.start === null || o.start === '') throw new Error('a moment needs a start');
    this.el = el;
    this.o = o;
    this.start = compile(o.start);
    this.end = (o.end !== undefined && o.end !== null && o.end !== '') ? compile(o.end) : null;
    this.curve = curve(o.curve);
    this.sets = [];
    var set = o.set || {};
    for (var k in set) {
      if (!Object.prototype.hasOwnProperty.call(set, k)) continue;
      if (!SETTABLE.test(k)) throw new Error('"set" takes custom properties and opacity only, not "' + k + '"');
      var pair = set[k];
      if (!pair || pair.length !== 2 || !isFinite(+pair[0]) || !isFinite(+pair[1])) throw new Error('"' + k + '" needs [from, to]');
      this.sets.push({ name: k, from: +pair[0], to: +pair[1], last: null });
    }
    this.cls = o['class'] || '';
    this.toggle = !!o.toggle;
    this.on = o.on || '';
    this.once = !!o.once;
    this.bands = o.bands ? [].concat(o.bands) : null;
    this.when = o.when ? [].concat(o.when) : null;
    this.reducedMode = o.reduced === 'start' || o.reduced === 'live' ? o.reduced : 'end';
    this.anchorSel = o.anchors ? [].concat(o.anchors) : [];
    this.failed = null;
    this.s = 0; this.e = 0;
    this.floorMs = 0; this.smooth = 0;
    this.raw = 0; this.fp = 0; this.sp = 0;
    this.progress = 0; this.value = 0;
    this.region = null;
    this.classOn = false; this.wantClass = false;
    this.fresh = true; this.pending = false; this.off = false; this.done = false;
    this.group = null;
  }
  Moment.prototype.remove = function () {
    var g = this.group;
    if (g) {
      var i = g.moments.indexOf(this);
      if (i >= 0) g.moments.splice(i, 1);
      if (!g.moments.length) removeGroup(g);
      else g.dirty = true;
    }
    clearWrites(this);
    this.group = null;
  };
  function clearWrites(m) {
    for (var i = 0; i < m.sets.length; i++) {
      var s = m.sets[i];
      if (s.last === null) continue;
      if (s.name === 'opacity') m.el.style.opacity = '';
      else m.el.style.removeProperty(s.name);
      s.last = null;
    }
    if (m.classOn) { m.el.classList.remove(m.cls); m.classOn = false; }
  }
  function regionOf(m, y) {
    if (m.end) return y < m.s ? -1 : y > m.e ? 1 : 0;
    return m.raw >= 1 ? 1 : -1;
  }
  function evaluate(m, y, dt) {
    var disabled = (m.bands && m.bands.indexOf(band) < 0) ||
      (m.when && m.when.some(function (c) { return html.classList.contains(c); }));
    if (disabled) {
      if (!m.off) { m.off = true; m.pending = 'off'; }
      return false;
    }
    if (m.off) { m.off = false; m.fresh = true; }
    var live = !reduced || m.reducedMode === 'live';
    var raw;
    if (!live) raw = m.reducedMode === 'start' ? 0 : 1;
    else if (m.end) raw = m.e > m.s ? clamp((y - m.s) / (m.e - m.s), 0, 1) : (y >= m.s ? 1 : 0);
    else raw = (m.raw >= 1 && !m.fresh) ? (y >= m.s - 1 ? 1 : 0) : (y >= m.s ? 1 : 0);
    var fp, sp;
    if (m.fresh || !live) { fp = raw; sp = raw; }
    else {
      fp = floorStep(m.fp, raw, dt, m.floorMs);
      sp = smoothStep(m.sp, fp, dt, m.smooth);
      if (Math.abs(fp - raw) < 1e-4) fp = raw;
      if (Math.abs(sp - fp) < 1e-4) sp = fp;
    }
    m.raw = raw; m.fp = fp; m.sp = sp;
    m.progress = sp;
    m.value = m.curve(sp);
    var region = live ? regionOf(m, y) : (m.reducedMode === 'start' ? -1 : (m.end ? 0 : 1));
    if (m.cls) {
      var inside = m.end ? region === 0 : region === 1;
      var passed = region >= 0;
      if (!m.end) passed = region === 1;
      m.wantClass = m.toggle ? inside : (m.classOn || passed);
    }
    if (m.on && !m.done && m.region !== region) {
      queueEvents(m, m.region, region);
    }
    m.region = region;
    m.fresh = false;
    m.pending = true;
    return fp !== raw || sp !== fp;
  }
  function queueEvents(m, from, to) {
    var dirs = [];
    if (!m.end) {
      if (from === null) { if (to === 1) dirs.push(['forward', true]); }
      else dirs.push([to === 1 ? 'forward' : 'back', false]);
    } else {
      var initial = from === null;
      if (initial) { if (to === 0) dirs.push(['enter', true]); }
      else if (to === 0) dirs.push(['enter', false]);
      else if (from === 0) dirs.push(['leave', false]);
      else { dirs.push(['enter', false]); dirs.push(['leave', false]); }
    }
    dirs.forEach(function (d) {
      events.push(function () {
        if (m.done || !m.group) return;
        try {
          m.el.dispatchEvent(new CustomEvent('ba:' + m.on, { bubbles: true, detail: { dir: d[0], initial: d[1], moment: m } }));
        } catch (e) { warn('event:' + m.on, 'ba:' + m.on + ' listener failed: ' + e.message); }
        if (m.once && (d[0] === 'enter' || d[0] === 'forward')) m.done = true;
      });
    });
  }
  function apply(m) {
    if (m.pending === 'off') { clearWrites(m); m.pending = false; return; }
    if (!m.pending) return;
    m.pending = false;
    for (var i = 0; i < m.sets.length; i++) {
      var s = m.sets[i], v = s.from + (s.to - s.from) * m.value, str;
      if (s.name === 'opacity') {
        str = String(+v.toFixed(3));
        if (str !== s.last) { s.last = str; m.el.style.opacity = str; }
      } else {
        str = String(+v.toFixed(4));
        if (str !== s.last) { s.last = str; m.el.style.setProperty(s.name, str); }
      }
    }
    if (m.cls && m.wantClass !== m.classOn) {
      m.classOn = m.wantClass;
      m.el.classList.toggle(m.cls, m.classOn);
    }
  }
  function safe(fn, label) {
    try { return fn(); } catch (e) { warn(label, label + ' failed: ' + e.message); }
  }
  function tick(now) {
    raf = 0;
    var dt = lastNow ? clamp(now - lastNow, 0, 50) : 16;
    lastNow = now;
    checkResize(now);
    if (groups.length) {
      var sh = html.scrollHeight;
      if (sh !== pageH) { pageH = sh; dirty = true; }
    }
    if (dirty) measure(true, now);
    else {
      for (var d = 0; d < groups.length; d++) { if (groups[d].dirty) { measure(false, now); break; } }
    }
    var y = G.scrollY || G.pageYOffset || 0;
    var moving = false, touched = [];
    for (var gi = groups.length - 1; gi >= 0; gi--) {
      var g = groups[gi];
      if (!g.root.isConnected) { destroyUnder(g.root); continue; }
      if (!g.force && !g.moving && prevY >= 0 &&
          ((y < g.min && prevY < g.min) || (y > g.max && prevY > g.max))) continue;
      g.force = false;
      g.moving = false;
      for (var mi = 0; mi < g.moments.length; mi++) {
        var m = g.moments[mi];
        if (m.failed) continue;
        if (evaluate(m, y, dt)) g.moving = true;
        touched.push(m);
      }
      if (g.moving) moving = true;
    }
    prevY = y;
    var rq = readQ; readQ = [];
    for (var r = 0; r < rq.length; r++) safe(rq[r].fn, 'a read hook');
    for (var w = 0; w < touched.length; w++) apply(touched[w]);
    var wq = writeQ; writeQ = [];
    for (var q = 0; q < wq.length; q++) safe(wq[q].fn, 'a write hook');
    var due = frames, keep = [];
    frames = [];
    for (var f = 0; f < due.length; f++) {
      var entry = due[f];
      if (entry.gone) continue;
      var more = false;
      try { more = entry.fn(now, dt) === true; } catch (e) { warn('frame', 'a frame hook failed: ' + e.message); }
      if (more && !entry.gone) keep.push(entry);
    }
    frames = keep.concat(frames);
    var ev = events; events = [];
    for (var k = 0; k < ev.length; k++) ev[k]();
    if (moving || frames.length || readQ.length || writeQ.length || events.length || resizeT) book();
    else lastNow = 0;
  }
  function groupFor(el) {
    var root = (el.closest && el.closest('.shopify-section')) || doc.body;
    for (var i = 0; i < groups.length; i++) if (groups[i].root === root) return groups[i];
    var g = { root: root, moments: [], min: -Infinity, max: Infinity, css: {}, dirty: true, force: true, moving: false };
    groups.push(g);
    watchHeight();
    return g;
  }
  function removeGroup(g) {
    var i = groups.indexOf(g);
    if (i >= 0) groups.splice(i, 1);
  }
  function dead(el, msg) {
    try { el.setAttribute('data-ba-moment-error', msg); } catch (_) {}
    warn('fail:' + msg, msg);
    return { el: el, failed: msg, progress: 0, value: 0, remove: function () {} };
  }
  function moment(el, opts) {
    if (!el || el.nodeType !== 1) throw new Error('baScroll.moment needs an element');
    if (el.closest && el.closest('[data-ba-arm-story]')) return dead(el, 'moments are never registered inside the film');
    var m;
    try { m = new Moment(el, opts || {}); } catch (err) { return dead(el, err.message); }
    var g = groupFor(el);
    m.group = g;
    g.moments.push(m);
    g.dirty = true;
    book();
    return m;
  }
  function scan(root) {
    var scope = root || doc;
    var els = [].slice.call(scope.querySelectorAll('[data-ba-moment]'));
    if (scope.nodeType === 1 && scope.hasAttribute('data-ba-moment')) els.unshift(scope);
    els.forEach(function (el) {
      if (el._baMoments) return;
      if (el.closest('[data-ba-arm-story]')) return;
      var list;
      try { list = JSON.parse(el.getAttribute('data-ba-moment')); }
      catch (e) { dead(el, 'data-ba-moment is not valid JSON'); return; }
      el._baMoments = [].concat(list).map(function (o) { return moment(el, o); });
    });
  }
  function destroyUnder(root) {
    for (var i = groups.length - 1; i >= 0; i--) {
      var g = groups[i];
      g.moments = g.moments.filter(function (m) {
        if (m.el === root || root.contains(m.el) || !m.el.isConnected) {
          clearWrites(m);
          m.group = null;
          if (m.el._baMoments) delete m.el._baMoments;
          return false;
        }
        return true;
      });
      if (!g.moments.length || root.contains(g.root) || !g.root.isConnected) removeGroup(g);
    }
    function outside(e) {
      var keep = !e.root || !(e.root === root || root.contains(e.root));
      if (!keep) e.gone = true;
      return keep;
    }
    frames = frames.filter(outside);
    readQ = readQ.filter(outside);
    writeQ = writeQ.filter(outside);
  }
  function markDirty() {
    dirty = true;
    if (busy()) book();
  }
  G.addEventListener('scroll', function () { if (busy()) book(); }, { passive: true });
  G.addEventListener('resize', function () { resizePending = true; if (busy()) book(); }, { passive: true });
  G.addEventListener('load', markDirty);
  G.setTimeout(markDirty, 3000);
  if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(markDirty, function () {});
  function onReduce() {
    reduced = mqReduce.matches;
    groups.forEach(function (g) { g.force = true; g.moments.forEach(function (m) { m.fresh = true; }); });
    events.push(function () { emit('reduced', reduced); });
    book();
  }
  if (mqReduce.addEventListener) mqReduce.addEventListener('change', onReduce);
  else if (mqReduce.addListener) mqReduce.addListener(onReduce);
  var SKIP_LOAD = /^(SCRIPT|STYLE|META|TITLE)$/;
  var SVGNS = 'http://www.w3.org/2000/svg';
  function onLoaded(e) {
    var t = e.target;
    if (!t || t.nodeType !== 1 || SKIP_LOAD.test(t.tagName)) return;
    if (t.tagName === 'LINK' && !/\bstylesheet\b/i.test(t.rel || '')) return;
    markDirty();
  }
  var heightWatched = false;
  function watchHeight() {
    if (heightWatched || !doc.body) return;
    heightWatched = true;
    doc.addEventListener('load', onLoaded, true);
    doc.addEventListener('toggle', markDirty, true);
    if (G.MutationObserver) {
      new G.MutationObserver(function (list) {
        for (var i = 0; i < list.length; i++) {
          var target = list[i].target;
          if (target.namespaceURI === SVGNS || (target.closest && target.closest('[data-ba-arm-story]'))) continue;
          var nodes = [].slice.call(list[i].addedNodes).concat([].slice.call(list[i].removedNodes));
          for (var k = 0; k < nodes.length; k++) {
            if (nodes[k].nodeType === 1 && nodes[k] !== probe) { markDirty(); return; }
          }
        }
      }).observe(doc.body, { childList: true, subtree: true });
    }
  }
  doc.addEventListener('shopify:section:unload', function (e) { if (e.target && e.target.nodeType === 1) destroyUnder(e.target); });
  doc.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.nodeType === 1) scan(e.target); markDirty(); });
  ['shopify:section:select', 'shopify:section:deselect', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (name) {
    doc.addEventListener(name, markDirty);
  });
  function boot() {
    band = bandNow();
    scan(doc);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot);
  else boot();
  function hook(list, fn, root) {
    if (typeof fn !== 'function') throw new Error('expected a function');
    list.push({ fn: fn, root: root || null, added: G.performance ? G.performance.now() : 0 });
    book();
  }
  G.baScroll = {
    version: '0.1.0',
    moment: moment,
    scan: scan,
    read: function (fn, root) { hook(readQ, fn, root); },
    write: function (fn, root) { hook(writeQ, fn, root); },
    frame: function (fn, root) { hook(frames, fn, root); },
    refresh: function (root) {
      if (!root) { dirty = true; }
      else {
        groups.forEach(function (g) { if (g.root === root || g.root.contains(root) || root.contains(g.root)) g.dirty = true; });
      }
      if (busy()) book();
    },
    scope: function (root) { return { destroy: function () { destroyUnder(root); } }; },
    on: function (name, fn) { (listeners[name] = listeners[name] || []).push(fn); },
    off: function (name, fn) {
      var l = listeners[name];
      if (l) { var i = l.indexOf(fn); if (i >= 0) l.splice(i, 1); }
    },
    maths: PURE,
    _count: function () { return groups.reduce(function (n, g) { return n + g.moments.length; }, 0); },
    _state: function () {
      return { vh: vh, vw: vw, band: band, reduced: reduced, groups: groups.length, booked: !!raf, frames: frames.length };
    }
  };
})(typeof window !== 'undefined' ? window : null);

(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';
  try {
    var nav = (performance.getEntriesByType &&
               performance.getEntriesByType('navigation')[0]) || null;
    var reloaded = nav ? nav.type === 'reload'
                       : (performance.navigation && performance.navigation.type === 1);
    if (reloaded) {
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      var toTop = function () {
        var pw = document.querySelector('.page-wrapper');
        var el = (pw && pw.scrollHeight > pw.clientHeight + 10) ? pw : document.scrollingElement;
        if (el && el.scrollTo) el.scrollTo({ top: 0, behavior: 'instant' });
        else window.scrollTo(0, 0);
      };
      toTop();
      window.addEventListener('pageshow', function () {
        requestAnimationFrame(function () { requestAnimationFrame(toTop); });
      });
    }
  } catch (_) {   }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function ease(p) { return p * p * p * (p * (p * 6 - 15) + 10); }
  function seg(v, a, b) { return ease(clamp((v - a) / ((b - a) || 1), 0, 1)); }
  function el(name, attrs) {
    var e = document.createElementNS(NS, name);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  function imperial(root) {
    var live = document.documentElement.getAttribute('data-ba-units');
    if (live === 'imperial') return true;
    if (live === 'metric') return false;
    var m = (root && root.dataset && root.dataset.baUnits) || 'auto';
    if (m === 'imperial') return true;
    if (m === 'metric') return false;
    var r = '';
    try { r = (new Intl.Locale(navigator.language)).region || ''; }
    catch (e) { r = (navigator.language.split('-')[1] || '').toUpperCase(); }
    return !r || r === 'US';
  }
  function reduced() {
    return matchMedia('(prefers-reduced-motion: reduce)').matches;
  }
  var ENTER = { rootMargin: '0px 0px -25% 0px', threshold: 0.35 };
  var EXIT = { rootMargin: '300px', threshold: 0 };
  function stage(root, opts) {
    var draw = opts.draw;
    var dur = opts.duration || 2000;
    var st = { on: false, done: false, t0: 0, raf: 0 };
    if (root._baStage) root._baStage.stop();
    if (root._baObs) root._baObs.forEach(function (o) { o.disconnect(); });
    root._baObs = [];
    root._baStage = st;
    if (reduced()) { draw(1); st.done = true; if (opts.onDone) opts.onDone(); return st; }
    var startDone = false;
    if (root._baUnitsSwap) {
      root._baUnitsSwap = false;
      startDone = !!root._baPlayed;
    }
    if (startDone) {
      st.done = true;
      draw(1);
      if (opts.onDone) opts.onDone();
    } else {
      draw(0);
    }
    function frame(now) {
      if (!root.isConnected || !st.on) return;
      var e = now - st.t0;
      st.p = clamp(e / dur, 0, 1);
      draw(st.p);
      if (e < dur + 60) st.raf = requestAnimationFrame(frame);
      else {
        st.done = true; root._baPlayed = true;
        draw(1);
        if (opts.onDone) opts.onDone();
      }
    }
    function startRun() {
      if (st.on || st.done) return;
      st.on = true;
      st.t0 = performance.now();
      st.raf = requestAnimationFrame(frame);
    }
    function exitRun() {
      if (st.done && opts.once) return;
      if (opts.once && (st.p || 0) > 0.6) {
        st.on = false; st.done = true;
        cancelAnimationFrame(st.raf);
        draw(1);
        if (opts.onDone) opts.onDone();
        return;
      }
      st.on = false;
      st.done = false;
      cancelAnimationFrame(st.raf);
      draw(0);
    }
    function seen() {
      var r = root.getBoundingClientRect();
      if (!r.height) return false;
      var visible = Math.min(r.bottom, innerHeight * 0.75) - Math.max(r.top, 0);
      return visible >= 0.35 * r.height - 0.5;
    }
    function pinned() {
      for (var e = root.parentElement; e && e !== document.body; e = e.parentElement) {
        if (getComputedStyle(e).position === 'sticky') return true;
      }
      return false;
    }
    var E = window.baScroll;
    if (E && E.moment && !opts.enter && !opts.exit && !pinned()) {
      var mIn = E.moment(root, { start: 't - 75vh + 35h', end: 'b - 35h', on: 'stage-in' });
      var mOut = E.moment(root, { start: 't - vh - 300px', end: 'b + 300px', on: 'stage-out' });
      if (mIn && !mIn.failed && mOut && !mOut.failed) {
        var lateIn = null;
        var onIn = function (ev) {
          if (ev.target !== root || ev.detail.dir !== 'enter') return;
          if (seen()) { startRun(); return; }
          if (lateIn) return;
          lateIn = new IntersectionObserver(function (es) {
            if (!es.some(function (x) { return x.isIntersecting; })) return;
            lateIn.disconnect();
            lateIn = null;
            startRun();
          }, ENTER);
          lateIn.observe(root);
        };
        var onOut = function (ev) { if (ev.target === root && ev.detail.dir === 'leave') exitRun(); };
        root.addEventListener('ba:stage-in', onIn);
        root.addEventListener('ba:stage-out', onOut);
        var r0 = root.getBoundingClientRect();
        if (r0.top >= innerHeight + 300 || r0.bottom <= -300) exitRun();
        root._baObs = [{ disconnect: function () {
          mIn.remove(); mOut.remove();
          if (lateIn) { lateIn.disconnect(); lateIn = null; }
          root.removeEventListener('ba:stage-in', onIn);
          root.removeEventListener('ba:stage-out', onOut);
        } }];
        st.stop = function () { st.on = false; cancelAnimationFrame(st.raf); };
        return st;
      }
      if (mIn && mIn.remove) mIn.remove();
      if (mOut && mOut.remove) mOut.remove();
    }
    var obsIn = new IntersectionObserver(function (es) {
      es.forEach(function (ev) {
        if (!ev.isIntersecting || st.on || st.done) return;
        startRun();
      });
    }, opts.enter || ENTER);
    obsIn.observe(root);
    var obsOut = new IntersectionObserver(function (es) {
      es.forEach(function (ev) {
        if (ev.isIntersecting) return;
        exitRun();
      });
    }, opts.exit || EXIT);
    obsOut.observe(root);
    root._baObs = [obsIn, obsOut];
    st.stop = function () { st.on = false; cancelAnimationFrame(st.raf); };
    return st;
  }
  function boot(selector, attach) {
    function run() { document.querySelectorAll(selector).forEach(attach); }
    if (document.readyState !== 'loading') run();
    else document.addEventListener('DOMContentLoaded', run);
    document.addEventListener('shopify:section:load', run);
    document.addEventListener('ba:units', function () {
      document.querySelectorAll(selector).forEach(function (r) {
        delete r.dataset.baBooted;
        r._baUnitsSwap = true;
      });
      run();
    });
  }
  var warned = {};
  function missing(name) {
    if (!warned[name]) {
      warned[name] = 1;
      if (window.console && console.warn) {
        console.warn('[BA] ' + name + ' is not loaded; figures depending on it will not draw.');
      }
    }
    return null;
  }
  var NAMES = { a: 'alpha', s: 'stock', l: 'lifts', r: 'rides',
                c: 'P', m: 'iso', q: 'p90', f: 'fan', h: 'hb' };
  function data() {
    var raw = window.BA_ARM_DATA;
    if (!raw) return missing('BA_ARM_DATA');
    if (raw.__view) return raw.__view;
    var view = {};
    for (var k in raw) {
      if (k === '__view') continue;
      view[NAMES[k] || k] = raw[k];
    }
    if (!view.iso) return missing('BA_ARM_DATA');
    try { Object.defineProperty(raw, '__view', { value: view, enumerable: false }); }
    catch (e) { raw.__view = view; }
    return view;
  }
  function ladder() {
    var l = window.BA_LADDER;
    return (l && l.window) ? l : missing('BA_LADDER');
  }
  function field() {
    var f = window.BA_ARM_FIELD;
    return (f && f.p && f.r && f.u) ? f : null;
  }
  function t(key, vars, fallback) {
    var dict = window.BA_T || {};
    var out = dict[key] || fallback || '';
    if (vars) {
      for (var k in vars) {
        if (Object.prototype.hasOwnProperty.call(vars, k)) {
          out = out.split('%' + k + '%').join(vars[k]);
        }
      }
    }
    return out;
  }
  function spring(zeta, omega, ms) {
    var n = 48, pts = [];
    var wd = omega * Math.sqrt(Math.max(0, 1 - zeta * zeta));
    for (var i = 0; i <= n; i++) {
      var tt = (i / n) * ms / 1000, x;
      if (zeta < 1) x = 1 - Math.exp(-zeta * omega * tt) * (Math.cos(wd * tt) + (zeta * omega / wd) * Math.sin(wd * tt));
      else x = 1 - Math.exp(-omega * tt) * (1 + omega * tt);
      pts.push((i === n ? 1 : x).toFixed(4));
    }
    return 'linear(' + pts.join(', ') + ')';
  }
  function ms(el, name, fallback) {
    var v = getComputedStyle(el || document.documentElement).getPropertyValue(name).trim();
    var n = parseFloat(v);
    if (isNaN(n)) return fallback;
    return /ms$/.test(v) ? n : /s$/.test(v) ? n * 1000 : n;
  }
  function motion(el) {
    return Object.freeze({
      turnStrip: ms(el, '--m-turn-strip', 500),
      turnHighlights: ms(el, '--m-turn-highlights', 500),
      settle: ms(el, '--m-settle', 160),
      landMax: ms(el, '--m-land-max', 2000),
      arriveLate: ms(el, '--m-arrive-late', 2500),
      dwell: ms(el, '--gal-dwell', 6000)
    });
  }
  motion.ms = ms;
  function warmRows() {
    var rows = document.querySelectorAll('.ba-gal:not([data-ba-warm])');
    if (!rows.length) return;
    function warm(row) {
      row.setAttribute('data-ba-warm', '');
      row.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });
    }
    if (!('IntersectionObserver' in window)) { rows.forEach(warm); return; }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (ev) { if (ev.isIntersecting) { warm(ev.target); io.unobserve(ev.target); } });
    }, { rootMargin: '100% 0px' });
    rows.forEach(function (r) { io.observe(r); });
  }
  if (document.readyState !== 'loading') warmRows();
  else document.addEventListener('DOMContentLoaded', warmRows);
  document.addEventListener('shopify:section:load', warmRows);
  window.BA = {
    clamp: clamp, ease: ease, seg: seg, el: el, t: t, spring: spring, motion: motion,
    imperial: imperial, reduced: reduced,
    stage: stage, boot: boot,
    data: data, ladder: ladder, field: field,
    ENTER: ENTER, EXIT: EXIT
  };
})();

(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var SEL = '.product-card, .collection-card, .resource-card';
  function arm() {
    var els = [].slice.call(document.querySelectorAll(SEL))
      .filter(function (el) { return !el.dataset.baMotion; });
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var kin = [].slice.call(el.parentElement ? el.parentElement.children : []);
        var k = Math.max(0, kin.indexOf(el));
        el.style.transitionDelay = Math.min(k % 6, 5) * 70 + 'ms';
        el.classList.add('ba-in');
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    els.forEach(function (el) {
      el.dataset.baMotion = '1';
      var r = el.getBoundingClientRect();
      if (r.top > innerHeight * 0.9) {
        el.classList.add('ba-will');
        io.observe(el);
      }
    });
  }
  if (document.readyState === 'loading') addEventListener('DOMContentLoaded', arm);
  else arm();
  new MutationObserver(function () { arm(); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.querySelector('.password-main-content')) return;
  var MARK = 'data-ba-reveal';
  var STAGGER_MS = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--a-reveal-stagger')) || 100;
  var MAX_STEPS = 6;
  var TARGETS = [
    'main .section > *:not(.resource-list):not(.section-background):not(.custom-section-background)',
    'main .resource-list__item',
    '.ba-open__copy', '.ba-open__figure',
    '.ba-sys__eyebrow', '.ba-sys__h', '.ba-sys__body', '.ba-sys__point',
    '.ba-det__eyebrow', '.ba-det__h', '.ba-det__item',
    '.ba-grid__eyebrow', '.ba-grid__h', '.ba-grid__body',
    '.ba-win__eyebrow', '.ba-win__h', '.ba-win__note',
    '.ba-bars__eyebrow', '.ba-bars__h', '.ba-bars__ratio', '.ba-bars__note',
    '.ba-story__eyebrow', '.ba-story__h', '.ba-story__sub', '.ba-story__outro',
    '.ba-spec__head', '.ba-spec__table tbody tr', '.ba-spec__note',
    '[data-ba-reveal-item]'
  ].join(', ');
  function arrive(el, rect) {
    var above = rect.bottom <= 0 || rect.top < 0;
    if (above) {
      el.style.transition = 'none';
      el.setAttribute(MARK, 'in');
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.style.transition = ''; }); });
      return;
    }
    el.style.setProperty('--ba-reveal-delay', el.dataset.baStagger || '0ms');
    el.setAttribute(MARK, 'in');
  }
  var observers = {};
  function lineOf(el) { return parseFloat(el.dataset.baRevealAt) || 85; }
  function observerFor(at) {
    var key = String(at);
    if (observers[key]) return observers[key];
    var ob = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var el = entry.target, r = entry.boundingClientRect;
        if (r.bottom <= 0 || (entry.isIntersecting && r.top < 0)) { arrive(el, r); ob.unobserve(el); return; }
        if (entry.isIntersecting) {
          arrive(el, r);
          ob.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -' + (100 - parseFloat(key)) + '% 0px', threshold: 0 });
    observers[key] = ob;
    return ob;
  }
  function observe(el) { observerFor(lineOf(el)).observe(el); }
  function pinned(el) {
    for (var e = el.parentElement; e && e !== document.body; e = e.parentElement) {
      if (getComputedStyle(e).position === 'sticky') return true;
    }
    return false;
  }
  function viaEngine(el) {
    var E = window.baScroll;
    if (!E || !E.moment || el.closest('[data-ba-arm-story]') || pinned(el)) { observe(el); return; }
    function restingRise(node) {
      var was = node.style.transition;
      node.style.transition = 'none';
      var tm = /matrix(3d)?\(([^)]+)\)/.exec(getComputedStyle(node).transform || '');
      node.style.transition = was;
      if (!tm) return 0;
      var tv = tm[2].split(',');
      return parseFloat(tm[1] ? tv[13] : tv[5]) || 0;
    }
    var lift = restingRise(el);
    var m = E.moment(el, { start: 't + ' + lift.toFixed(2) + 'px - ' + lineOf(el) + 'vh', on: 'reveal', once: true });
    if (!m || m.failed) { observe(el); return; }
    el.addEventListener('ba:reveal', function onReveal(ev) {
      if (ev.target !== el || ev.detail.dir !== 'forward') return;
      el.removeEventListener('ba:reveal', onReveal);
      m.remove();
      var r = el.getBoundingClientRect();
      if (r.right <= 0 || r.left >= (document.documentElement.clientWidth || innerWidth)) { observe(el); return; }
      if (r.bottom > 0 && r.top > innerHeight * lineOf(el) / 100) { observe(el); return; }
      arrive(el, r);
    });
  }
  function collect() {
    var groups = new Map();
    document.querySelectorAll(TARGETS).forEach(function (el) {
      if (el.hasAttribute(MARK)) return;
      if (el.closest('header-component, .header, footer, .cart-drawer')) return;
      if (el.closest('.ba-story__pin, .ba-grid__figure, .ba-win__figure, .ba-bars__chart')) return;
      if (!el.offsetWidth && !el.offsetHeight) return;
      var siblings = groups.get(el.parentElement) || 0;
      groups.set(el.parentElement, siblings + 1);
      if (!el.dataset.baStagger) el.dataset.baStagger = Math.min(siblings, MAX_STEPS) * STAGGER_MS + 'ms';
      el.style.setProperty('--ba-reveal-delay', el.dataset.baStagger);
      el.setAttribute(MARK, 'out');
      viaEngine(el);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collect);
  } else {
    collect();
  }
  document.addEventListener('shopify:section:load', collect);
})();

(function () {
  'use strict';
  var BA = window.BA;
  if (!BA) return;
  function intro(bar, o) {
    o = o || {};
    var pill = o.pill, btn = o.btn;
    if (!bar || !bar.animate || BA.reduced() || bar._baIntroDone) return Promise.resolve();
    bar._baIntroDone = true;
    var sp = BA.spring;
    var bounce = sp(0.4, 10, 1600), soft = sp(0.5, 10, 1200);
    var out = 'cubic-bezier(0.25, 1, 0.5, 1)';
    var anims = [];
    function run(el, frames, opts) {
      try { var a = el.animate(frames, opts); anims.push(a); return a; } catch (e) { return null; }
    }
    run(bar, [{ transform: 'translateY(180px)' }, { transform: 'translateY(0)' }],
      { duration: 1600, delay: 30, easing: bounce, fill: 'backwards' });
    var seed = document.createElement('span');
    seed.className = 'ba-pl__seed';
    seed.setAttribute('aria-hidden', 'true');
    bar.appendChild(seed);
    run(seed, [{ opacity: 0 }, { opacity: 1 }], { duration: 60, delay: 20, fill: 'backwards' });
    run(seed, [
      { width: '30px', height: '80px', transform: 'translate(-50%, -50%) translateX(-15px) scale(1.3)' },
      { width: '56px', height: '56px', transform: 'translate(-50%, -50%) translateX(-28px) scale(0.8)' }
    ], { duration: 1000, delay: 50, easing: bounce, fill: 'backwards' });
    var seedOut = run(seed, [{ opacity: 1 }, { opacity: 0 }], { duration: 120, delay: 520, fill: 'forwards' });
    var gone = function () { seed.remove(); };
    if (seedOut) seedOut.finished.then(gone, gone); else gone();
    if (pill) {
      var pw = pill.offsetWidth, ph = pill.offsetHeight;
      pill.style.overflow = 'hidden';
      run(pill, [{ transform: 'scale(0)' }, { transform: 'scale(1)' }],
        { duration: 400, delay: 300, easing: out, fill: 'backwards' });
      run(pill, [{ width: '40px' }, { width: pw + 'px' }],
        { duration: 1200, delay: 500, easing: soft, fill: 'backwards' });
      run(pill, [{ height: '36px' }, { height: ph + 'px' }],
        { duration: 1000, delay: 700, easing: soft, fill: 'backwards' });
      var dots = pill.children, n = dots.length, mid = (n - 1) / 2;
      for (var i = 0; i < n; i++) {
        var dir = i < mid ? -1 : (i > mid ? 1 : 0);
        run(dots[i], [{ opacity: 0, transform: 'translateX(' + (36 * dir) + 'px)' }, { opacity: 1, transform: 'none' }],
          { duration: 600, delay: 740 + 20 * i, easing: sp(0.7, 14.1, 600), fill: 'backwards' });
      }
    }
    if (btn) {
      run(btn, [{ transform: 'scale(0)' }, { transform: 'scale(1)' }],
        { duration: 400, delay: 540, easing: out, fill: 'backwards' });
      run(btn, [{ width: '80px', height: '36px' }, { width: '56px', height: '56px' }],
        { duration: 1000, delay: 700, easing: soft, fill: 'backwards' });
      var mark = btn.querySelector('svg');
      if (mark) run(mark, [{ opacity: 0, transform: 'scale(0.5)' }, { opacity: 1, transform: 'scale(1)' }],
        { duration: 200, delay: 940, easing: 'ease-out', fill: 'backwards' });
    }
    [pill, btn].forEach(function (el) {
      if (!el) return;
      var rest = parseFloat(getComputedStyle(el).getPropertyValue('--pl-alpha')) || 0.72;
      run(el, [{ '--pl-alpha': 1 }, { '--pl-alpha': rest }], { duration: 300, delay: 1000, fill: 'backwards' });
    });
    return Promise.all(anims.map(function (a) { return a.finished.catch(function () {}); }))
      .then(function () { if (pill) pill.style.overflow = ''; });
  }
  BA.playerIntro = intro;
  BA.boot('[data-ba-player-intro]', function (el) {
    var pill = el.querySelector('[data-ba="track"], [data-ba="gal-dots"]');
    var btn = el.querySelector('[data-ba="play"], [data-ba="gal-play"]');
    function go() { intro(el, { pill: pill, btn: btn }); }
    if (el.classList.contains('in')) { go(); return; }
    var mo = new MutationObserver(function () {
      if (el.classList.contains('in')) { mo.disconnect(); go(); }
    });
    mo.observe(el, { attributes: true, attributeFilter: ['class'] });
  });
})();

(function () {
  'use strict';
  var BUILT = 'data-ba-dd';
  function textOf(a) {
    var s = a.querySelector('.wrap-text');
    return (s ? s.textContent : a.textContent).trim();
  }
  function harvest(submenu) {
    var groups = [];
    submenu.querySelectorAll('.mega-menu__link--parent').forEach(function (p) {
      var kids = [];
      var list = p.nextElementSibling;
      if (list && list.tagName === 'UL') {
        list.querySelectorAll('a').forEach(function (a) {
          kids.push({ title: textOf(a), url: a.getAttribute('href') });
        });
      }
      groups.push({ title: textOf(p), url: p.getAttribute('href'), children: kids });
    });
    submenu.querySelectorAll('.mega-menu__link').forEach(function (a) {
      if (a.classList.contains('mega-menu__link--parent')) return;
      if (a.closest('ul') && a.closest('ul').previousElementSibling
          && a.closest('ul').previousElementSibling.classList
          && a.closest('ul').previousElementSibling.classList.contains('mega-menu__link--parent')) return;
      groups.push({ title: textOf(a), url: a.getAttribute('href'), children: [] });
    });
    return groups.filter(function (g) { return g.title; });
  }
  function build(groups) {
    var wrap = document.createElement('div');
    wrap.className = 'ba-dd';
    var ul = document.createElement('ul');
    ul.className = 'ba-dd__list';
    groups.forEach(function (g) {
      var li = document.createElement('li');
      li.className = 'ba-dd__group';
      var row = document.createElement('div');
      row.className = 'ba-dd__row';
      var a = document.createElement('a');
      a.className = 'ba-dd__parent';
      a.href = g.url || '#';
      a.textContent = g.title;
      row.appendChild(a);
      if (g.children.length) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ba-dd__toggle';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-label', (window.BA && BA.t ? BA.t('a11y.show_submenu', { title: g.title }, 'Show %title% submenu') : 'Show ' + g.title + ' submenu'));
        btn.innerHTML = '<span class="ba-dd__caret"></span>';
        row.appendChild(btn);
        var sub = document.createElement('ul');
        sub.className = 'ba-dd__children';
        sub.hidden = true;
        g.children.forEach(function (c) {
          var cli = document.createElement('li');
          var ca = document.createElement('a');
          ca.className = 'ba-dd__child';
          ca.href = c.url || '#';
          ca.textContent = c.title;
          cli.appendChild(ca);
          sub.appendChild(cli);
        });
        btn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          var open = btn.getAttribute('aria-expanded') === 'true';
          ul.querySelectorAll('.ba-dd__toggle[aria-expanded="true"]').forEach(function (o) {
            if (o !== btn) { o.setAttribute('aria-expanded', 'false');
              o.closest('.ba-dd__group').querySelector('.ba-dd__children').hidden = true; }
          });
          btn.setAttribute('aria-expanded', open ? 'false' : 'true');
          sub.hidden = open;
        });
        li.appendChild(row);
        li.appendChild(sub);
      } else {
        li.appendChild(row);
      }
      ul.appendChild(li);
    });
    wrap.appendChild(ul);
    return wrap;
  }
  function enhance() {
    document.querySelectorAll('.menu-list__submenu').forEach(function (submenu) {
      if (submenu.hasAttribute(BUILT)) return;
      var inner = submenu.querySelector('.menu-list__submenu-inner');
      if (!inner) return;
      var groups = harvest(submenu);
      if (!groups.length) return;
      submenu.setAttribute(BUILT, '1');
      inner.replaceChildren(build(groups));
    });
  }
  var DESKTOP = '(min-width: 750px)';
  var FORCED = ['position', 'left', 'top', 'right', 'bottom', 'width', 'height',
                'max-height', 'visibility', 'opacity', 'pointer-events',
                'transform', 'display', 'z-index', 'margin'];
  function scrollTargets() {
    var wrap = document.querySelector('.page-wrapper');
    return wrap ? [wrap, window] : [window];
  }
  function place(li, sub) {
    var r = li.getBoundingClientRect();
    sub.style.setProperty('left', Math.round(r.left) + 'px', 'important');
    sub.style.setProperty('top', Math.round(r.bottom + 6) + 'px', 'important');
  }
  function portalOut(li, sub) {
    if (!window.matchMedia(DESKTOP).matches) return;
    if (sub.__baHome) return;
    sub.__baHome = { parent: sub.parentNode, next: sub.nextSibling, li: li };
    document.body.appendChild(sub);
    sub.classList.add('ba-dd-portal');
    sub.classList.add('color-custom-popover');
    sub.style.setProperty('position', 'fixed', 'important');
    sub.style.setProperty('right', 'auto', 'important');
    sub.style.setProperty('bottom', 'auto', 'important');
    sub.style.setProperty('height', 'auto', 'important');
    sub.style.setProperty('max-height', 'none', 'important');
    sub.style.setProperty('visibility', 'visible', 'important');
    sub.style.setProperty('opacity', '1', 'important');
    sub.style.setProperty('pointer-events', 'auto', 'important');
    sub.style.setProperty('transform', 'none', 'important');
    sub.style.setProperty('display', 'block', 'important');
    sub.style.setProperty('margin', '0', 'important');
    sub.style.setProperty('z-index', '1000', 'important');
    place(li, sub);
    sub.__baPlace = function () { place(li, sub); };
    window.addEventListener('resize', sub.__baPlace);
    scrollTargets().forEach(function (t) {
      t.addEventListener('scroll', sub.__baPlace, { passive: true });
    });
  }
  function portalBack(sub) {
    if (!sub || !sub.__baHome) return;
    if (sub.__baPlace) {
      window.removeEventListener('resize', sub.__baPlace);
      scrollTargets().forEach(function (t) {
        t.removeEventListener('scroll', sub.__baPlace);
      });
      sub.__baPlace = null;
    }
    FORCED.forEach(function (prop) { sub.style.removeProperty(prop); });
    sub.classList.remove('ba-dd-portal');
    sub.classList.remove('color-custom-popover');
    var home = sub.__baHome;
    sub.__baHome = null;
    var parent = home.parent && home.parent.isConnected ? home.parent : home.li;
    if (!parent || !parent.isConnected) { sub.remove(); return; }
    if (home.next && home.next.parentNode === parent) {
      parent.insertBefore(sub, home.next);
    } else {
      parent.appendChild(sub);
    }
  }
  var wired = false;
  function isDesktop() { return window.matchMedia(DESKTOP).matches; }
  function panelOf(li) {
    if (li.__baSub && (li.contains(li.__baSub) || li.__baSub.__baHome)) return li.__baSub;
    li.__baSub = li.querySelector('.menu-list__submenu');
    return li.__baSub;
  }
  function closeItem(li) {
    var sub = panelOf(li);
    if (sub) {
      sub.querySelectorAll('[aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var group = t.closest('.ba-dd__group');
        var kids = group && group.querySelector('.ba-dd__children');
        if (kids) kids.hidden = true;
      });
    }
    li.querySelectorAll('[aria-expanded="true"]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
    delete li.dataset.baOpen;
    if (sub) { portalBack(sub); sub.setAttribute('inert', ''); }
  }
  function closeAll(except) {
    document.querySelectorAll('.menu-list__list-item[data-ba-open]').forEach(function (li) {
      if (li !== except) closeItem(li);
    });
  }
  function openItem(li) {
    li.dataset.baOpen = '1';
    var sub = panelOf(li);
    if (sub) { sub.removeAttribute('inert'); portalOut(li, sub); }
    li.querySelectorAll('.menu-list__disclosure, .menu-list__link').forEach(function (el) {
      if (el.hasAttribute('aria-expanded')) el.setAttribute('aria-expanded', 'true');
    });
  }
  function clickToOpen() {
    if (wired) return;
    wired = true;
    ['pointerenter', 'pointerleave', 'mouseenter', 'mouseleave'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        if (!isDesktop() || !e.target || !e.target.closest) return;
        var li = e.target.closest('.menu-list__list-item');
        if (li && panelOf(li)) e.stopPropagation();
      }, true);
    });
    document.addEventListener('click', function (e) {
      if (!isDesktop() || !e.target || !e.target.closest) return;
      if (e.target.closest('.ba-dd-portal') || e.target.closest('.menu-list__submenu')) return;
      var li = e.target.closest('.menu-list__list-item');
      if (li && !li.matches('[slot="overflow"]') && panelOf(li)) {
        e.preventDefault();
        e.stopPropagation();
        var open = li.dataset.baOpen === '1';
        closeAll(li);
        if (open) closeItem(li); else openItem(li);
        return;
      }
      if (!e.target.closest('.menu-list')) closeAll();
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }
  function boot() { enhance(); clickToOpen(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
  new MutationObserver(boot).observe(document.documentElement, { childList: true, subtree: true });
})();

(function () {
  'use strict';
  var KEY = 'ba-units';
  var root = document.documentElement;
  function byRegion() {
    var r = (root.getAttribute('data-ba-country') || '').toUpperCase();
    if (!r) {
      try { r = (new Intl.Locale(navigator.language)).region || ''; }
      catch (e) { r = (navigator.language.split('-')[1] || '').toUpperCase(); }
    }
    if (!r) return 'imperial';
    return (r === 'US' || r === 'LR' || r === 'MM') ? 'imperial' : 'metric';
  }
  function stored() {
    try { var v = localStorage.getItem(KEY); return v === 'imperial' || v === 'metric' ? v : null; }
    catch (e) { return null; }
  }
  function resolve() {
    var chosen = stored();
    if (chosen) return chosen;
    var themeDefault = root.getAttribute('data-ba-units-default') || 'auto';
    if (themeDefault === 'imperial' || themeDefault === 'metric') return themeDefault;
    return byRegion();
  }
  var current = resolve();
  root.setAttribute('data-ba-units', current);
  function apply(v, remember) {
    if (v !== 'imperial' && v !== 'metric') return;
    current = v;
    root.setAttribute('data-ba-units', v);
    if (remember) { try { localStorage.setItem(KEY, v); } catch (e) {} }
    syncButtons();
    syncWeights();
    document.dispatchEvent(new CustomEvent('ba:units', { detail: { units: v } }));
  }
  function fmtWeight(grams, imperial, only) {
    if (!isFinite(grams) || grams <= 0) return null;
    if (imperial) {
      var oz = grams / 28.349523125, lb = grams / 453.59237;
      var force = only === 'lb' || only === 'oz' ? only : null;
      var pref = force || root.getAttribute('data-ba-small-imperial') || 'lb';
      if (force === 'oz' || (pref === 'oz' && Math.round(oz) < 16)) return Math.round(oz) + ' oz';
      if (Math.round(lb * 10) < 10) return String(+lb.toFixed(2)) + ' lb';
      return lb.toFixed(1) + ' lb';
    }
    return Math.round(grams) < 1000 ? Math.round(grams) + ' g' : (grams / 1000).toFixed(1) + ' kg';
  }
  function syncWeights() {
    var imperial = current === 'imperial';
    document.querySelectorAll('[data-ba-weight]').forEach(function (el) {
      var out = fmtWeight(parseFloat(el.getAttribute('data-ba-weight')), imperial, el.getAttribute('data-ba-weight-in'));
      if (out) el.textContent = out;
    });
  }
  function syncButtons() {
    document.querySelectorAll('[data-ba-units-toggle]').forEach(function (b) {
      var imperial = current === 'imperial';
      b.setAttribute('aria-pressed', String(imperial));
      b.setAttribute('aria-label', imperial ? 'Switch to kilograms' : 'Switch to pounds');
      b.setAttribute('title', imperial ? 'Showing pounds' : 'Showing kilograms');
    });
  }
  var INLINE = /\{\s*(\d+(?:[.,]\d+)?)\s*(kg|g|lbs?|oz)(?:\s+in\s+(lb|oz))?\s*\}/gi;
  var TO_GRAMS = { g: 1, kg: 1000, oz: 28.349523125, lb: 453.59237, lbs: 453.59237 };
  function inlineWeights() {
    if (!document.body || document.body.textContent.indexOf('{') === -1) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeValue.indexOf('{') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentNode;
        if (!p || (p.closest && p.closest('script, style, textarea, svg, [contenteditable], [data-ba-weight]'))) return NodeFilter.FILTER_REJECT;
        INLINE.lastIndex = 0;
        return INLINE.test(n.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var hits = [], n;
    while ((n = walker.nextNode())) hits.push(n);
    hits.forEach(function (node) {
      var text = node.nodeValue, frag = document.createDocumentFragment(), last = 0, m;
      INLINE.lastIndex = 0;
      while ((m = INLINE.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var grams = parseFloat(m[1].replace(',', '.')) * TO_GRAMS[m[2].toLowerCase()];
        var span = document.createElement('span');
        span.setAttribute('data-ba-weight', String(Math.round(grams * 10) / 10));
        if (m[3]) span.setAttribute('data-ba-weight-in', m[3].toLowerCase());
        span.textContent = fmtWeight(grams, current === 'imperial', m[3] && m[3].toLowerCase()) || m[0];
        frag.appendChild(span);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }
  function relevant() {
    return !!document.querySelector('[data-ba-units], [data-ba-weight]');
  }
  function wire() {
    inlineWeights();
    var useful = relevant();
    document.querySelectorAll('[data-ba-units-toggle]').forEach(function (b) {
      b.hidden = !useful;
    });
    if (!useful) return;
    syncButtons();
    syncWeights();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ba-units-toggle]');
    if (!b) return;
    apply(current === 'imperial' ? 'metric' : 'imperial', true);
  });
  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
  document.addEventListener('shopify:section:load', wire);
  if ('MutationObserver' in window) {
    var pending = 0;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        for (var j = 0; j < muts[i].addedNodes.length; j++) {
          var n = muts[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches && n.matches('[data-ba-units-toggle]') ||
              n.querySelector && n.querySelector('[data-ba-units-toggle]'))) {
            clearTimeout(pending);
            pending = setTimeout(wire, 40);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  window.BAUnits = {
    get: function () { return current; },
    imperial: function () { return current === 'imperial'; },
    set: function (v) { apply(v, true); },
    format: function (grams, imperial, only) { return fmtWeight(grams, imperial, only); }
  };
})();

(function () {
  'use strict';
  var SCOPE = '.ba-grid, .ba-bars, .ba-feel, .ba-story, .ba-sys, .ba-det, .ba-spec, .ba-open, .ba-sum, .ba-compare, ' +
              '.ba-kit, .ba-viewer, .ba-tabs, .ba-gal, .ba-stats, .ba-faq, .ba-inc, .ba-idx, .ba-hero, .ba-chips, .ba-shead';
  var MARK = /\[(note|\d{1,2}|[a-z][a-z0-9-]{1,30})\]/i;
  var SYMBOLS = ['*', '**', '\u25ca', '\u2020', '\u2021', '\u00a7'];
  var NUMBERED = [];
  function number() {
    KEYS = {};
    NUMBERED = [];
    var legal = 0, n = 0;
    document.querySelectorAll('.ba-notes__item').forEach(function (li) {
      var isLegal = li.getAttribute('data-ba-note-kind') === 'legal';
      var label;
      if (isLegal) {
        label = SYMBOLS[legal] || SYMBOLS[SYMBOLS.length - 1];
        legal++;
      } else {
        n++;
        label = String(n);
        NUMBERED[n] = li;
      }
      li.id = 'ba-note-' + (isLegal ? 'legal-' + legal : n);
      var printed = li.querySelector('.ba-notes__n');
      if (printed && printed.textContent !== label) printed.textContent = label;
      var key = (li.getAttribute('data-ba-note-key') || '').toLowerCase();
      if (key) KEYS[key] = { label: label, id: li.id };
    });
    return {};
  }
  var keys = 0;
  function hostKey(el) {
    if (!el._baKey) el._baKey = 'k' + (++keys);
    return el._baKey;
  }
  function decorate(scope, own) {
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || !MARK.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        if (n.parentElement.closest('.ba-fn, .ba-notes')) return NodeFilter.FILTER_REJECT;
        if (n.parentElement.closest('svg')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var hits = [], n;
    while ((n = walker.nextNode())) hits.push(n);
    hits.forEach(function (node) {
      var frag = document.createDocumentFragment();
      var rest = node.nodeValue, m;
      while ((m = rest.match(MARK))) {
        if (m.index) frag.appendChild(document.createTextNode(rest.slice(0, m.index).replace(/ $/, '\u00a0')));
        var num = null, target = null;
        var named = KEYS[m[1].toLowerCase()];
        if (named) { num = named.label; target = named.id; }
        else if (/^\d+$/.test(m[1])) {
          var li = NUMBERED[+m[1]];
          if (li) { num = m[1]; target = li.id; }
        }
        if (!num) {
          frag.appendChild(document.createTextNode(m[0]));
          rest = rest.slice(m.index + m[0].length);
          continue;
        }
        var sup = document.createElement('sup');
        sup.className = 'ba-fn';
        var a = document.createElement('a');
        a.href = '#' + (target || 'ba-note-' + num);
        a.textContent = num;
        a.setAttribute('aria-label', (window.BA && BA.t ? BA.t('a11y.see_note', { n: num }, 'See note %n%') : 'See note ' + num));
        sup.appendChild(a);
        frag.appendChild(sup);
        rest = rest.slice(m.index + m[0].length);
      }
      if (rest) frag.appendChild(document.createTextNode(rest));
      node.parentNode.replaceChild(frag, node);
    });
  }
  var KEYS = {};
  function run() {
    var map = number();
    document.querySelectorAll(SCOPE).forEach(function (el) {
      decorate(el, null);
    });
  }
  function noteNumber(nameOrDigit) {
    var v = String(nameOrDigit == null ? '' : nameOrDigit).trim();
    if (!v) return '';
    var found = KEYS[v.toLowerCase()];
    if (found) return found.label;
    if (/^\d+$/.test(v) && NUMBERED[+v]) return v;
    return '';
  }
  window.BA = window.BA || {};
  window.BA.noteNumber = noteNumber;
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  document.addEventListener('shopify:section:load', run);
  if ('MutationObserver' in window) {
    var pending = 0;
    var opts = { childList: true, subtree: true, characterData: true };
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = 0;
        obs.disconnect();
        try { run(); } finally { obs.observe(document.body, opts); }
      }, 150);
    });
    obs.observe(document.body, opts);
  }
})();

(function () {
  'use strict';
  var BA = window.BA;
  if (!BA) return;
  function attach(root) {
    if (root.dataset.baBooted) return;
    root.dataset.baBooted = '1';
    var stats = [].slice.call(root.querySelectorAll('[data-ba-stat]')).map(function (el) {
      var t = el.textContent.trim();
      var m = t.match(/^([^0-9\-]*)(-?[\d.,]+)(.*)$/);
      if (!m) return null;
      var num = parseFloat(m[2].replace(/,/g, ''));
      if (isNaN(num)) return null;
      var dp = (m[2].split('.')[1] || '').length;
      return { el: el, pre: m[1], num: num, post: m[3], dp: dp };
    }).filter(Boolean);
    if (!stats.length) return;
    BA.stage(root, {
      duration: 1800,
      once: true,
      enter: { rootMargin: '0px 0px -8% 0px', threshold: 0.12 },
      draw: function (p) {
        var e = BA.ease(p);
        stats.forEach(function (s) {
          s.el.textContent = s.pre + (s.num * e).toFixed(s.dp) + s.post;
        });
      }
    });
  }
  BA.boot('[data-ba-stats]', attach);
})();

(function () {
  var root = document.documentElement;
  var sections = [];
  function sync() {
    var h = document.querySelector('header');
    if (!h) return;
    var v = Math.round(h.getBoundingClientRect().height);
    if (v > 0 && root.style.getPropertyValue('--ba-header-h') !== v + 'px') root.style.setProperty('--ba-header-h', v + 'px');
  }
  function collect() { sections = [].slice.call(document.querySelectorAll('main .shopify-section')); }
  function groundOf(el) {
    var g = el.getAttribute('data-ba-ground');
    if (g) return g;
    var m = /rgba?\(([\d.]+),\s*([\d.]+),\s*([\d.]+)(?:,\s*([\d.]+))?/.exec(getComputedStyle(el).backgroundColor);
    if (!m || (m[4] !== undefined && +m[4] < 0.5)) return 'page';
    return (0.2126 * m[1] + 0.7152 * m[2] + 0.0722 * m[3]) < 128 ? 'dark' : 'page';
  }
  function readNav() {
    var h = document.querySelector('header');
    if (!h) return null;
    var foot = Math.max(h.getBoundingClientRect().bottom, 0) + 1;
    var bar = document.querySelector('.ba-lnav__bar');
    if (bar) foot = Math.max(foot, bar.getBoundingClientRect().bottom + 2);
    for (var i = 0; i < sections.length; i++) {
      var r = sections[i].getBoundingClientRect();
      if (r.height && r.top <= foot && r.bottom > foot) {
        var el = sections[i].querySelector('[data-ba-ground]') || sections[i].firstElementChild || sections[i];
        return { nav: groundOf(el) === 'page' ? 'light' : 'dark', clear: el.getAttribute('data-ba-header') === 'clear' && r.bottom > foot + 8 };
      }
    }
    return { nav: 'light', clear: false };
  }
  function writeNav(s) {
    if (!s) return;
    if (root.getAttribute('data-ba-nav') !== s.nav) root.setAttribute('data-ba-nav', s.nav);
    root.toggleAttribute('data-ba-nav-clear', s.clear);
  }
  function navState() { writeNav(readNav()); }
  var queued = false, pending = null;
  function tick() {
    if (queued) return;
    queued = true;
    var E = window.baScroll;
    if (E && E.read && E.write) {
      E.read(function () { queued = false; pending = readNav(); });
      E.write(function () { writeNav(pending); });
    } else {
      requestAnimationFrame(function () { queued = false; navState(); });
    }
  }
  addEventListener('scroll', tick, { passive: true });
  addEventListener('resize', function () { sync(); tick(); if (window.baHeroZoom) window.baHeroZoom(); }, { passive: true });
  addEventListener('load', function () { sync(); collect(); navState(); });
  var SVGNS = 'http://www.w3.org/2000/svg';
  new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      var target = list[i].target;
      if (target.namespaceURI === SVGNS || (target.closest && target.closest('[data-ba-arm-story]'))) continue;
      var nodes = [].slice.call(list[i].addedNodes).concat([].slice.call(list[i].removedNodes));
      for (var k = 0; k < nodes.length; k++) {
        if (nodes[k].nodeType === 1) { sync(); collect(); tick(); return; }
      }
    }
  }).observe(document.body || root, { childList: true, subtree: true });
  sync(); collect(); navState();
})();

(function () {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function attach(box) {
    if (box.dataset.baBooted) return;
    box.dataset.baBooted = '1';
    var v = box.querySelector('video');
    if (!v) return;
    var pauseOnExit = box.dataset.baVideoPauseOnExit !== 'false';
    var unloadAtEnd = box.dataset.baVideoUnloadAtEnd === 'true';
    var holdEnd = box.dataset.baVideoHoldEnd === 'true';
    var timeout = parseInt(box.dataset.baVideoTimeout || '3000', 10);
    var manual = box.dataset.baVideoManual === 'true';
    var timer = 0, done = false, held = false;
    var pp = box.querySelector('[data-ba-video-pp]');
    v.addEventListener('playing', function () {
      clearTimeout(timer);
      box.classList.add('is-playing');
    });
    v.addEventListener('ended', function () {
      done = true;
      if (holdEnd) { box.classList.add('is-ended'); return; }
      box.classList.remove('is-playing');
      if (unloadAtEnd) {
        var src = v.querySelector('source');
        if (src) { v.removeAttribute('src'); src.dataset.src = src.src; src.removeAttribute('src'); }
        try { v.load(); } catch (e) {}
      }
    });
    if (pp) pp.addEventListener('click', function () {
      held = !held;
      box.classList.toggle('is-held', held);
      pp.setAttribute('aria-label', held ? pp.dataset.a11yPlay : pp.dataset.a11yPause);
      if (held) { try { v.pause(); } catch (e) {} } else { start(); }
    });
    function start() {
      if (done || held) return;
      var src = v.querySelector('source');
      if (src && !src.src && src.dataset.src) { src.src = src.dataset.src; v.load(); }
      var p = v.play();
      if (p && p.catch) p.catch(function () {   });
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!box.classList.contains('is-playing')) { try { v.pause(); } catch (e) {} }
      }, timeout);
    }
    function stop() {
      clearTimeout(timer);
      if (pauseOnExit && !v.paused) v.pause();
    }
    if (manual) {
      v.addEventListener('play', function () {
        clearTimeout(timer);
        timer = setTimeout(function () {
          if (!box.classList.contains('is-playing')) { try { v.pause(); } catch (e) {} }
        }, timeout);
      });
      return;
    }
    new IntersectionObserver(function (es) {
      var vis = es.some(function (e) { return e.isIntersecting; });
      if (vis) start(); else stop();
    }, { threshold: 0.25 }).observe(box);
  }
  function init() { document.querySelectorAll('[data-ba-video]').forEach(attach); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  'use strict';
  var MAX_ADD = 2;
  var MAX_TIGHT = -0.05;
  function px(el, v) { return v * parseFloat(getComputedStyle(el).fontSize); }
  function explode(el) {
    var src = el._baFitHTML;
    if (src === undefined) { src = el._baFitHTML = el.innerHTML; }
    el.innerHTML = src;
    var out = [];
    var walk = [].slice.call(el.childNodes);
    walk.forEach(function (n) {
      if (n.nodeType === 3) {
        var frag = document.createDocumentFragment();
        n.nodeValue.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (!part.trim()) { frag.appendChild(document.createTextNode(' ')); return; }
          var w = document.createElement('span');
          w.className = 'ba-fit__w';
          w.textContent = part;
          frag.appendChild(w);
          out.push(w);
        });
        n.parentNode.replaceChild(frag, n);
      } else if (n.nodeType === 1 && n.tagName === 'BR') {
        out.push(n);
      } else if (n.nodeType === 1) {
        out.push(null);
      }
    });
    return out.indexOf(null) >= 0 ? null : out;
  }
  function lines(parts) {
    var rows = [], cur = null, top = null;
    parts.forEach(function (p) {
      if (p.tagName === 'BR') { cur = null; top = null; return; }
      var t = Math.round(p.getBoundingClientRect().top);
      if (cur === null || Math.abs(t - top) > 2) { cur = []; rows.push(cur); top = t; }
      cur.push(p);
    });
    return rows.filter(function (r) { return r.length; });
  }
  function naturalWidth(row) {
    var a = row[0].getBoundingClientRect(), b = row[row.length - 1].getBoundingClientRect();
    return b.right - a.left;
  }
  function ink(line) {
    var r = document.createRange();
    r.selectNodeContents(line);
    return r.getBoundingClientRect().width;
  }
  function fit(el, target, holder) {
    el.style.maxWidth = '';
    if (holder && holder !== el) holder.style.maxWidth = '';
    var parts = explode(el);
    if (!parts) { el.innerHTML = el._baFitHTML; return 0; }
    var rows = lines(parts);
    if (!rows.length) return 0;
    var widths = rows.map(naturalWidth);
    var aim = target || Math.max.apply(null, widths);
    var ceiling = parseFloat(el.getAttribute('data-ba-fit-max') ||
                             (el.parentElement && el.parentElement.getAttribute('data-ba-fit-max')) || MAX_ADD);
    var maxAdd = px(el, ceiling), maxTight = px(el, MAX_TIGHT);
    var frag = document.createDocumentFragment();
    var made = [];
    rows.forEach(function (row, i) {
      var text = row.map(function (w) { return w.textContent; }).join(' ');
      var chars = text.replace(/\s+$/, '').length;
      var line = document.createElement('span');
      line.className = 'ba-fit__line';
      line.textContent = text;
      var gaps = chars - 1;
      if (gaps > 0) {
        set(line, clamp((aim - widths[i]) / gaps));
        made.push({ line: line, gaps: gaps });
      }
      if (frag.lastChild) frag.appendChild(document.createTextNode(' '));
      frag.appendChild(line);
    });
    function clamp(v) { return v > maxAdd ? maxAdd : (v < maxTight ? maxTight : v); }
    function set(line, ls) {
      line.style.letterSpacing = ls.toFixed(3) + 'px';
      line.style.marginRight = (-ls).toFixed(3) + 'px';
      line._baLs = ls;
    }
    el.innerHTML = '';
    el.appendChild(frag);
    el.style.maxWidth = 'none';
    if (holder && holder !== el) holder.style.maxWidth = 'none';
    made.forEach(function (m) {
      var off = aim - ink(m.line);
      if (Math.abs(off) > 0.5) set(m.line, clamp(m.line._baLs + off / m.gaps));
    });
    var achieved = 0;
    [].slice.call(el.children).forEach(function (line) {
      var w = ink(line);
      if (w > achieved) achieved = w;
    });
    el._baFitWidth = achieved;
    return achieved;
  }
  function root(attrEl) {
    if (attrEl._baFitRoot) return attrEl._baFitRoot;
    var n = attrEl, guard = 0;
    while (guard++ < 4) {
      var kids = [].slice.call(n.children);
      if (kids.length !== 1) break;
      var kid = kids[0];
      if (kid.classList.contains('ba-fit__line')) break;
      if (kid.textContent.trim() !== (n.textContent || '').trim()) break;
      n = kid;
    }
    attrEl._baFitRoot = n;
    return n;
  }
  function run() {
    var attrs = [].slice.call(document.querySelectorAll('[data-ba-fit]'));
    attrs.forEach(function (a) { if (!a.getAttribute('data-ba-fit')) fit(root(a), 0, a); });
    attrs.forEach(function (a) {
      var sel = a.getAttribute('data-ba-fit');
      if (!sel) return;
      var refEl = document.querySelector(sel);
      var ref = refEl ? root(refEl) : null;
      fit(root(a), ref ? (ref._baFitWidth || ref.getBoundingClientRect().width) : 0, a);
    });
  }
  var pending = 0;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(run, 120);
  }
  function start() {
    run();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

(function () {
  'use strict';
  function attach(root) {
    if (root.dataset.baBooted) return;
    root.dataset.baBooted = '1';
    var track = root.querySelector('[data-ba-tabs-track]');
    if (track) [].forEach.call(root.querySelectorAll('[data-ba-tabs-pill]'), function (p) { track.appendChild(p); });
    var tabs = [].slice.call(root.querySelectorAll('[role="tab"]'));
    var panes = [].slice.call(root.querySelectorAll('[role="tabpanel"]'));
    var prev = root.querySelector('[data-ba="tabs-prev"]');
    var next = root.querySelector('[data-ba="tabs-next"]');
    var strip = root.querySelector('[data-ba="tabs-strip"]');
    var closeBtn = root.querySelector('[data-ba="tabs-close"]');
    if (!tabs.length || tabs.length !== panes.length) return;
    var select = root.querySelector('select[data-ba-tabs-select]');
    if (select) {
      tabs.forEach(function (t, k) {
        var o = document.createElement('option');
        o.value = String(k); o.textContent = t.textContent.trim();
        select.appendChild(o);
      });
      select.addEventListener('change', function () { show(parseInt(select.value, 10) || 0); });
    }
    var CLOSABLE = root.hasAttribute('data-ba-tabs-closable');
    var LOOP = !!root.dataset.baTabsLoop && !root.classList.contains('ba-viewer');
    var REST = root.querySelector('[data-ba-rest]');
    var chosen = tabs.findIndex(function (t) { return t.getAttribute('aria-selected') === 'true'; });
    if (CLOSABLE && chosen < 0 && root.hasAttribute('data-ba-tabs-open-first')) chosen = 0;
    var current = CLOSABLE ? chosen : Math.max(0, chosen);
    var booting = true;
    var GROW = root.hasAttribute('data-ba-tabs-grow') && !!tabs[0].animate;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    function still() { return reduce && reduce.matches; }
    function PHONE() { return window.matchMedia && window.matchMedia('(max-width: 734px)').matches; }
    function sizes() {
      return tabs.map(function (t) {
        var r = t.getBoundingClientRect();
        return { w: r.width, h: r.height };
      });
    }
    function spring(zeta, omega, ms) {
      var n = 40, pts = [];
      var wd = omega * Math.sqrt(Math.max(0, 1 - zeta * zeta));
      for (var i = 0; i <= n; i++) {
        var t = (i / n) * ms / 1000, x;
        if (zeta < 1) {
          x = 1 - Math.exp(-zeta * omega * t) * (Math.cos(wd * t) + (zeta * omega / wd) * Math.sin(wd * t));
        } else {
          x = 1 - Math.exp(-omega * t) * (1 + omega * t);
        }
        pts.push((i === n ? 1 : x).toFixed(4));
      }
      return 'linear(' + pts.join(', ') + ')';
    }
    function easingOK(e) {
      try { document.body.animate([{ opacity: 1 }], { duration: 1, easing: e }).cancel(); return true; }
      catch (err) { return false; }
    }
    function grow(before) {
      if (!before) return;
      var cs = getComputedStyle(root);
      var dur = parseFloat(cs.getPropertyValue('--pill-grow')) || 700;
      var zeta = parseFloat(cs.getPropertyValue('--pill-zeta')) || 0.70;
      var omega = parseFloat(cs.getPropertyValue('--pill-omega')) || 12.9;
      var back = spring(zeta, omega, dur), out = spring(1, omega, dur);
      if (PHONE()) {
        dur = parseFloat(cs.getPropertyValue('--pill-grow-phone')) || 600;
        back = out = spring(parseFloat(cs.getPropertyValue('--pill-zeta-phone')) || 0.84, parseFloat(cs.getPropertyValue('--pill-omega-phone')) || 12.57, dur);
      }
      if (!easingOK(back)) {
        back = cs.getPropertyValue('--e-back').trim() || 'cubic-bezier(0.24, 1.37, 0.5, 1)';
        out = cs.getPropertyValue('--e-out').trim() || 'cubic-bezier(0, 0, 0.2, 1)';
      }
      var after = sizes();
      if (PHONE() && strip && root.classList.contains('is-open')) {
        var pad = parseFloat(getComputedStyle(strip).paddingTop) + parseFloat(getComputedStyle(strip).paddingBottom);
        var hb = 0, ha = 0;
        before.forEach(function (s) { if (s && s.h > hb) hb = s.h; });
        after.forEach(function (s) { if (s && s.h > ha) ha = s.h; });
        if (hb > 0 && Math.abs(hb - ha) >= 1) {
          if (strip._baGrow) strip._baGrow.cancel();
          strip._baGrow = strip.animate(
            [{ height: (hb + pad) + 'px', minHeight: (hb + pad) + 'px' }, { height: (ha + pad) + 'px', minHeight: (ha + pad) + 'px' }],
            { duration: dur, easing: back, fill: 'none' }
          );
        }
      }
      tabs.forEach(function (t, k) {
        var a = before[k], b = after[k];
        if (!a || !b) return;
        if (Math.abs(a.w - b.w) < 1 && Math.abs(a.h - b.h) < 1) return;
        if (t._baGrow) t._baGrow.cancel();
        t.style.overflow = 'hidden';
        var growing = (b.w * b.h) > (a.w * a.h);
        var anim = t.animate(
          [{ width: a.w + 'px', height: a.h + 'px', minHeight: a.h + 'px' },
           { width: b.w + 'px', height: b.h + 'px', minHeight: b.h + 'px' }],
          { duration: dur, easing: growing ? back : out, fill: 'none' }
        );
        t._baGrow = anim;
        function done() {
          if (t._baGrow !== anim) return;
          t.style.overflow = '';
          t._baGrow = null;
        }
        if (anim.finished) anim.finished.then(done, done);
        else anim.onfinish = done;
      });
    }
    var OUT_MS = parseFloat(getComputedStyle(root).getPropertyValue('--pane-out')) || 200;
    function paneIn(p) {
      clearTimeout(p._hideT);
      if (booting && p.hidden) { p.hidden = false; p.classList.remove('is-out', 'is-pre'); p.classList.add('is-in'); return; }
      if (!p.hidden && p.classList.contains('is-in')) return;
      p.classList.remove('is-out'); p.classList.add('is-pre'); p.hidden = false;
      void p.offsetWidth;
      requestAnimationFrame(function () { p.classList.remove('is-pre'); p.classList.add('is-in'); });
    }
    function paneOut(p) {
      if (p.hidden) return;
      p.classList.remove('is-in', 'is-pre'); p.classList.add('is-out');
      clearTimeout(p._hideT);
      p._hideT = setTimeout(function () { p.hidden = true; p.classList.remove('is-out'); }, OUT_MS + 20);
    }
    var autoUntil = 0, scrubbing = false;
    function rowPos() {
      var c = strip.getBoundingClientRect(), mid = c.left + c.width / 2, pts = [];
      tabs.forEach(function (t) { var r = t.getBoundingClientRect(); pts.push(r.left + r.width / 2); });
      if (mid <= pts[0]) return 0;
      for (var k = 0; k < pts.length - 1; k++) {
        if (mid <= pts[k + 1]) return k + (mid - pts[k]) / Math.max(1, pts[k + 1] - pts[k]);
      }
      return pts.length - 1;
    }
    function scrub(pos) {
      var k = Math.floor(pos), f = pos - k;
      scrubbing = true;
      panes.forEach(function (p, j) {
        var o = j === k ? Math.min(1, 2 * (1 - f)) : j === k + 1 ? f : 0;
        clearTimeout(p._hideT);
        p.classList.remove('is-pre', 'is-out');
        p.style.transition = 'none';
        p.style.opacity = String(o);
        p.hidden = o <= 0;
      });
    }
    function endScrub(best) {
      scrubbing = false;
      panes.forEach(function (p, j) {
        p.style.transition = ''; p.style.opacity = '';
        if (j === best) { p.hidden = false; p.classList.add('is-in'); }
        else { p.hidden = true; p.classList.remove('is-in'); }
      });
    }
    if (strip) {
      var settleT = null;
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
        strip.addEventListener(ev, function () { autoUntil = 0; }, { passive: true });
      });
      strip.addEventListener('scroll', function () {
        if (!root.classList.contains('is-open') || !matchMedia('(max-width: 734px)').matches) return;
        if (!strip.classList.contains('is-tweening') && performance.now() > autoUntil) scrub(rowPos());
        clearTimeout(settleT);
        settleT = setTimeout(function () {
          var best = Math.max(0, Math.min(tabs.length - 1, Math.round(rowPos())));
          if (scrubbing) endScrub(best);
          if (best !== current) show(best, false, true);
        }, 120);
      }, { passive: true });
    }
    var slideRaf = 0;
    function slideTo(tab) {
      var from = strip.scrollLeft;
      var to = tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2;
      if (still()) { strip.scrollLeft = to; return; }
      cancelAnimationFrame(slideRaf);
      strip.classList.add('is-tweening');
      var rcs = getComputedStyle(root);
      var t0 = performance.now(), w = parseFloat(rcs.getPropertyValue('--pill-omega-phone')) || 12.57, z = parseFloat(rcs.getPropertyValue('--pill-zeta-phone')) || 0.84, wd = w * Math.sqrt(1 - z * z);
      (function step(now) {
        var t = (now - t0) / 1000;
        var e = 1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + (z * w / wd) * Math.sin(wd * t));
        var done = t >= 0.75;
        strip.scrollLeft = from + (to - from) * (done ? 1 : e);
        if (!done) slideRaf = requestAnimationFrame(step);
        else strip.classList.remove('is-tweening');
      })(t0);
    }
    function show(i, focus, quiet) {
      var before = (GROW && !still() && !quiet) ? sizes() : null;
      if (CLOSABLE && i < 0) {
        current = -1;
        tabs.forEach(function (t, k) {
          t.setAttribute('aria-selected', 'false');
          t.tabIndex = k === 0 ? 0 : -1;
          paneOut(panes[k]);
          var vv = panes[k].querySelector('video');
          if (vv && !vv.paused) vv.pause();
        });
        if (REST) paneIn(REST);
        root.classList.remove('is-open');
        grow(before);
        if (prev) prev.disabled = true;
        if (next) next.disabled = false;
        return;
      }
      current = LOOP ? (i + tabs.length) % tabs.length : Math.max(0, Math.min(tabs.length - 1, i));
      if (REST) paneOut(REST);
      if (CLOSABLE) {
        root.classList.add('is-open');
        if (!booting) root.classList.add('has-opened');
      }
      if (!quiet) autoUntil = performance.now() + 1300;
      if (!quiet && tabs[current] && strip && matchMedia('(max-width: 734px)').matches) {
        if (root.classList.contains('is-open')) slideTo(tabs[current]);
        else { try { tabs[current].scrollIntoView({ inline: 'start', block: 'nearest', behavior: still() ? 'instant' : 'smooth' }); } catch (e) {} }
      }
      tabs.forEach(function (t, k) {
        var on = k === current;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on) paneIn(panes[k]); else paneOut(panes[k]);
        var v = panes[k].querySelector('video');
        if (v && !on && !v.paused) v.pause();
      });
      root.style.setProperty('--ba-tabs-index', current);
      if (select) select.selectedIndex = current;
      var phoneRow = matchMedia('(max-width: 734px)').matches && root.classList.contains('is-open');
      if (!quiet && strip && !phoneRow && tabs[current].scrollIntoView) {
        tabs[current].scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      }
      grow(before);
      if (prev) prev.disabled = !LOOP && current === 0;
      if (next) next.disabled = !LOOP && current === tabs.length - 1;
      if (focus) tabs[current].focus({ preventScroll: true });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () {
        var sel = window.getSelection && window.getSelection();
        if (current === k && sel && String(sel).length > 1 && t.contains(sel.anchorNode)) return;
        show(CLOSABLE && current === k ? -1 : k);
      });
      t.addEventListener('keydown', function (e) {
        var i = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') i = current + 1;
        else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') i = back();
        else if (e.key === 'Home') i = 0;
        else if (e.key === 'End') i = tabs.length - 1;
        if (i === null) return;
        e.preventDefault(); show(i, true);
      });
    });
    if (closeBtn) closeBtn.addEventListener('click', function () { show(-1); });
    function back() { return current === 0 ? (LOOP ? tabs.length - 1 : 0) : current - 1; }
    if (prev) prev.addEventListener('click', function () { show(back()); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    root.addEventListener('ba:edit-select', function (e) {
      var k = e.detail ? e.detail.index : -1;
      if (!tabs[k] || current === k) return;
      show(k, false, true);
    });
    show(current, false, true);
    booting = false;
  }
  function init() { document.querySelectorAll('[data-ba-tabs]').forEach(attach); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
